"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmTabItem = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-case-declarations */
const react_1 = __importStar(require("react"));
const useTab_1 = require("./useTab");
exports.SmTabItem = (0, react_1.forwardRef)((_a, ref) => {
    var { title, disabled } = _a, props = __rest(_a, ["title", "disabled"]);
    const context = (0, react_1.useContext)(useTab_1.TabContext);
    const innerRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, () => innerRef.current);
    const findEdgeTab = (elements, reverse = false) => {
        var _a, _b;
        if (!elements) {
            return null;
        }
        let index = reverse ? (elements === null || elements === void 0 ? void 0 : elements.length) - 1 : 0;
        let isDisabled = (_a = elements === null || elements === void 0 ? void 0 : elements.item(index)) === null || _a === void 0 ? void 0 : _a.getAttribute('disabled');
        while (isDisabled === '') {
            index = reverse ? index - 1 : index + 1;
            isDisabled = (_b = elements === null || elements === void 0 ? void 0 : elements.item(index)) === null || _b === void 0 ? void 0 : _b.getAttribute('disabled');
        }
        return elements === null || elements === void 0 ? void 0 : elements.item(index);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const findNextTab = (element, reverse = false) => {
        const isDisabled = element === null || element === void 0 ? void 0 : element.getAttribute('disabled');
        if (isDisabled === '') {
            return findNextTab(reverse
                ? element === null || element === void 0 ? void 0 : element.previousElementSibling
                : element === null || element === void 0 ? void 0 : element.nextElementSibling, reverse);
        }
        return element;
    };
    const onKeyDown = (event) => {
        var _a, _b, _c, _d, _e, _f;
        if (event.ctrlKey || event.shiftKey) {
            return;
        }
        switch (event.key) {
            case 'Right':
            case 'ArrowRight':
                const next = findNextTab((_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.nextElementSibling);
                next === null || next === void 0 ? void 0 : next.focus();
                break;
            case 'Left':
            case 'ArrowLeft':
                const previous = findNextTab((_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.previousElementSibling, true);
                previous === null || previous === void 0 ? void 0 : previous.focus();
                break;
            case 'End':
                const last = findEdgeTab((_d = (_c = innerRef.current) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.children, true);
                last === null || last === void 0 ? void 0 : last.focus();
                break;
            case 'Home':
                const first = findEdgeTab((_f = (_e = innerRef.current) === null || _e === void 0 ? void 0 : _e.parentElement) === null || _f === void 0 ? void 0 : _f.children);
                first === null || first === void 0 ? void 0 : first.focus();
                break;
            default:
                break;
        }
    };
    return (react_1.default.createElement("button", Object.assign({}, props, { ref: innerRef, role: "tab", "aria-selected": context === null || context === void 0 ? void 0 : context.selected, "aria-expanded": context === null || context === void 0 ? void 0 : context.selected, "aria-controls": `${context === null || context === void 0 ? void 0 : context.label}-tab`, className: `c-tab__button ${(context === null || context === void 0 ? void 0 : context.selected) ? '-active' : ''}`, title: title, tabIndex: 0, onKeyDown: (event) => {
            var _a;
            onKeyDown(event);
            (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, event);
        }, type: "button", disabled: disabled, onClick: (event) => {
            var _a;
            context === null || context === void 0 ? void 0 : context.onActivate();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
        } }),
        react_1.default.createElement("div", { className: "c-tab__buttonDecoration" }, title)));
});
//# sourceMappingURL=SmTabItem.js.map